import { render } from "./navigationTabs.vue?vue&type=template&id=338a552c&scoped=true"
import script from "./navigationTabs.vue?vue&type=script&lang=js"
export * from "./navigationTabs.vue?vue&type=script&lang=js"

import "./navigationTabs.vue?vue&type=style&index=0&id=338a552c&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3442\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338a552c"]])

export default __exports__